import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from 'app/core/user/user.service';

@Injectable({
	providedIn: 'root',
})
export class GroupGuard implements CanActivate {
	constructor(
		private readonly userService: UserService,
		private readonly router: Router,
	) {}

	canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
		const requiredGroups: string[] = route.data.groups;
		if (!Array.isArray(requiredGroups) || requiredGroups.length === 0) {
			return true;
		}

		const userGroups = this.userService.getAllAccessGroups();
		const isAdmin = userGroups.includes('admin');

		if (isAdmin) return true;

		const hasAccess = requiredGroups.some((group) =>
			userGroups.some(ug => ug === group || ug.startsWith(group + '-'))
		);
		if (!hasAccess) {
			this.router.navigateByUrl('/apps/tasks');
			return false;
		}

		return true;
	}
}
